import { axiosClient } from '../../../../utils/axiosClient';
import { makeApiRequest, type ApiResponse } from '../../../utils';
import { PointsEndpoints } from './pointsEndpoints';
import type { SeedOfGoodPointsResponse } from './response';

export class PointsService {
    public async getSeedOfGood(
        receiptId: number | string,
    ): Promise<ApiResponse<SeedOfGoodPointsResponse>> {
        const url = PointsEndpoints.seedOfGood(receiptId);
        const httpRequest = axiosClient.get(url);
        const result =
            await makeApiRequest<SeedOfGoodPointsResponse>(httpRequest);
        return result;
    }
}
